import {immerable} from 'immer';

export type HibuFacetGroup = {
    fieldName: string;
    values: FacetValue[];
    errorCode?: HibuFacetErrorCode;
}

export type FacetValue = {
    name: string;
    count: number;
    value: string;
    filter: HibuFilter;
}

export enum HibuFacetErrorCode {
    OVERFLOW_FACET_COUNT = 'OVERFLOW_FACET_COUNT',
    COUNT_NOT_AVAILABLE = 'COUNT_NOT_AVAILABLE',
}

export enum FacetValuesSortOrder {
    COUNT = 'count',
    NAME = 'name',
    VALUE = 'value'
}

export type HibuFacetFilter = {
    [key: string]: HibuFilter[];
};

export type HibuFilter = HibuRangeFilter | HibuEqualsFilter;

export const RANGE = 'range';
export const EQUALS = 'equals';

export class HibuRangeFilter {
    [immerable] = true;

    type: string;
    gte: string;
    lt: string;

    constructor(gte: string, lt: string) {
        this.type = RANGE;
        this.gte = gte;
        this.lt = lt;
    }
}

export class HibuEqualsFilter {
    [immerable] = true;

    type: string;
    value: string;
    invert: boolean;

    constructor(value: string) {
        this.type = EQUALS;
        if (value.startsWith('-')) {
            this.value = value.substring(1); // remove leading '-'
            this.invert = true;
        } else {
            this.value = value;
            this.invert = false;
        }
    }
}
